export default __webpack_public_path__ + "static/media/lbInnovations.9f50539b.webp";